<dashboardnav>
  
    <cradua-purpose
    [purposes]="purposes$ | async"
    (purpose)="onSubmitPurpose($event)"
    (deletePurposeEvent)="onDeletePurpose($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-purpose>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  